import request from '../../utils/request';

// MCP admin assistant Phase 1 — read-only diagnostics endpoints.
export function diagnoseOrder(orderCode) {
  return request(`/diagnostics/order/${encodeURIComponent(orderCode)}`, { method: 'GET' });
}

export function checkDay(date) {
  return request(`/diagnostics/day/${date}`, { method: 'GET' });
}

export function routeHealth(routeId) {
  return request(`/diagnostics/route/${routeId}`, { method: 'GET' });
}

// OVO-292 — trace ANY external id (partner order id, orderRef, orderCode,
// Airtable record id) through intake → upload verdict → order → logs.
// `partner` (Sep 2026) narrows the trace to one partner — external ids are
// not unique across partners.
export function traceExternalId(q, partner) {
  return request('/diagnostics/trace', { method: 'GET', params: partner ? { q, partner } : { q } });
}
